import HomePageSearchRequest from "@/models/HomePageSearchRequest";
import VERTICAL_OPTIONS from "./VerticalOptions";
import SORT_OPTIONS from "./SortOptions";
import { AdSortOrderKey } from "@/actions/search/services/AdSortService";
import { AreaSearch } from "@/models/HomePageSearchResponse";

// AJB: can this just create an instance?  Doubling up on defaults anyway
const DEFAULT_SEARCH_REQUEST: HomePageSearchRequest = {
  vertical: VERTICAL_OPTIONS[0],
  categories: [],
  breeds: [],
  disciplines: [],
  locations: [],
  colours: [],
  genders: [],
  riderLevels: [],

  searchQuery: "",

  price: { min: -1, max: -1 },
  age: { min: -1, max: -1 },
  height: { min: -1, max: -1 },
  
  area: new AreaSearch(),

  sortBy: SORT_OPTIONS[0].id as AdSortOrderKey,
  page: 1,
};

export default DEFAULT_SEARCH_REQUEST;
